import React, {lazy, Suspense} from 'react';
import {Switch, Route} from 'react-router-dom';
import Auth from '../redux/components/Auth';

import MatchPay from './MatchPay';
import {Error404} from './common/Error';
import {CenteredSpinner} from './common/Loading';
import Header from './Header';
import UIDemo from './UIDemo';
import UserSettings from './UserSettings';
import ManageAppDefaults from './ManageAppDefaults';

function RootMainBody(props) {
    const ApproveInvoices = lazy(
        () => import('./ApproveInvoices/ApproveInvoices')
    );
    const Dashboard = lazy(() => import('./Dashboard'));
    const InvoiceEdit = lazy(() => import('./InvoiceEdit'));
    const TabbedResearch = lazy(
        () => import('./InvoiceResearch/TabbedResearch')
    );
    const ManageExceptions = lazy(() => import('./ManageExceptions'));
    const AdminForms = lazy(() => import('./AdminForms'));
    const CarrierAdmin = lazy(() => import('./CarrierAdmin'));
    const CustomerAdmin = lazy(() => import('./CustomerAdmin'));

    const ITAdmin = lazy(() => import('./ITAdmin/ITAdmin'));

    return (
        <div>
            <div className="mainBody mb-2">
                <Suspense fallback={<CenteredSpinner></CenteredSpinner>}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={(props) => <Dashboard {...props} />}
                        />
                        <Route
                            path="/approveinvoices"
                            render={(props) => <ApproveInvoices {...props} />}
                        />
                        <Route
                            path="/matchpay"
                            render={(props) => <MatchPay {...props} />}
                        />
                        <Route
                            exact
                            path="/invoice/:type/:id"
                            render={(props) => <InvoiceEdit {...props} />}
                        />
                        <Route
                            path="/invoices"
                            render={(props) => <TabbedResearch {...props} />}
                        />
                        <Route
                            path="/uidemo"
                            render={(props) => <UIDemo {...props}></UIDemo>}
                        />
                        <Route
                            path="/usersettings"
                            render={(props) => (
                                <UserSettings {...props}></UserSettings>
                            )}
                        />
                        <Route
                            path="/manageExceptions"
                            render={(props) => (
                                <ManageExceptions {...props}></ManageExceptions>
                            )}
                        />
                        <Route
                            path="/itadmin"
                            render={(props) => <ITAdmin {...props}></ITAdmin>}
                        />
                        <Route
                            path="/adminForms"
                            render={(props) => <AdminForms {...props} />}
                        />
                        <Route
                            path="/carrierAdmin"
                            render={(props) => <CarrierAdmin {...props} />}
                        />
                        <Route
                            path="/customerAdmin"
                            render={(props) => <CustomerAdmin {...props} />}
                        />
                        <Route
                            path="/appdefaults"
                            render={(props) => (
                                <ManageAppDefaults
                                    {...props}></ManageAppDefaults>
                            )}
                        />
                        <Route render={(props) => <Error404 {...props} />} />
                    </Switch>
                </Suspense>
            </div>
        </div>
    );
}

export const MainBody = () => (
    <Auth header={<Header></Header>}>
        <RootMainBody></RootMainBody>
    </Auth>
);
